// extracted by mini-css-extract-plugin
module.exports = {"price":"Price_price__5cH3p","loading":"Price_loading__a8wJv","discounted":"Price_discounted__ZFtOK","discountedLoading":"Price_discountedLoading__j96iq"};